import { sources } from '../../content/system'
import Icon from './Icon'
import Cased from '@/components/ui/Cased'
export default function SourceLinks({
  ids,
}: {
  ids: (keyof typeof sources)[]
}) {
  return (
    <section className="doc-section doc-sources" aria-label="References">
      <h2><Cased>Reference points</Cased></h2>
      <p>MDS applies established federal and accessibility guidance.</p>
      <ul className="doc-sources__list">
        {ids.map((id) => (
          <li key={id}>
            <a className="mds-link" href={sources[id].url}>
              {sources[id].title}
              <Icon name="external" size={13} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
